webpackJsonp([7],{

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _HeroMain = __webpack_require__(628);

var _HeroMain2 = _interopRequireDefault(_HeroMain);

var _Trackable = __webpack_require__(594);

var _Trackable2 = _interopRequireDefault(_Trackable);

var _MetaTags = __webpack_require__(595);

var _MetaTags2 = _interopRequireDefault(_MetaTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAGS = {
    title: 'Intento 404',
    og: { title: 'Intento 404', url: 'https://inten.to/404' }
};

var NotFound = function NotFound() {
    return _react2.default.createElement(
        _Trackable2.default,
        { page: '404' },
        _react2.default.createElement(_MetaTags2.default, { tags: TAGS }),
        _react2.default.createElement(_HeroMain2.default, null),
        _react2.default.createElement(
            'section',
            { className: 'section features-section' },
            _react2.default.createElement(
                'div',
                { className: 'section__container container' },
                _react2.default.createElement(
                    'header',
                    { className: 'section__header' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'section__title h2' },
                        '404 - Oh no\'s! We couldn\'t find that page :('
                    )
                )
            )
        )
    );
};

exports.default = NotFound;

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(592);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroBase = function HeroBase(_ref) {
    var children = _ref.children,
        cols = _ref.cols,
        center = _ref.center,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('hero hero--main hero--gradient-blue ' + (center ? 'hero--center' : ''), className)
        },
        _react2.default.createElement(
            'div',
            { className: 'hero__container container' },
            _react2.default.createElement(
                'div',
                { className: cols ? 'hero__cols' : 'hero__content' },
                children
            )
        )
    );
};

exports.default = HeroBase;

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trackable = function (_React$Component) {
    _inherits(Trackable, _React$Component);

    function Trackable() {
        _classCallCheck(this, Trackable);

        return _possibleConstructorReturn(this, (Trackable.__proto__ || Object.getPrototypeOf(Trackable)).apply(this, arguments));
    }

    _createClass(Trackable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var page = this.props.page;

            if (!window.userLanded) {
                var params = {
                    page: page,
                    ab_group: (0, _utils.getCookieValue)('ab_group')
                    // locale: i18n.lng()
                };

                (0, _utils.track)('User landed', params, function () {
                    window.userLanded = true;
                    window.ab_group = (0, _utils.getCookieValue)('ab_group');
                });
            }

            // track page open as well, regardless of the initial landing
            (0, _utils.track)('Page opened', {
                page: page
                // locale: i18n.lng()
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className;

            return _react2.default.createElement(
                'main',
                { className: 'content ' + className },
                children
            );
        }
    }]);

    return Trackable;
}(_react2.default.Component);

exports.default = Trackable;

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// changes here requires dev server to restart
// because this component is used in the site config `static.config.js`

var LOGO = 'https://inten.to/img/brain.png';
var DESCRIPTION = 'Discover, evaluate and use best-of-breed AI. A simple and elegant API to third-party AI models from many vendors.';
var TITLE = 'Intento';

var DEFAULT_TAGS = {
    title: TITLE,
    description: DESCRIPTION,
    logo: LOGO,
    author: 'Intento Inc.',
    twitter: {
        title: TITLE,
        description: DESCRIPTION,
        image: LOGO
    },
    og: {
        title: TITLE,
        site_name: TITLE,
        description: DESCRIPTION,
        image: LOGO,
        imageHeight: 300,
        imageWidth: 300,
        url: 'https://inten.to/'
    }
};

var MetaTags = function MetaTags(props) {
    var _props$tags = props.tags,
        tags = _props$tags === undefined ? DEFAULT_TAGS : _props$tags;

    var meta = _extends({}, DEFAULT_TAGS, tags, {
        description: (tags.description || '') + ' \u2014 ' + DESCRIPTION,
        twitter: _extends({}, DEFAULT_TAGS.twitter, tags.twitter, {
            description: ((tags.twitter || {}).description || '') + ' \u2014 ' + DESCRIPTION
        }),
        og: _extends({}, DEFAULT_TAGS.og, tags.og, {
            description: ((tags.og || {}).description || '') + ' \u2014 ' + DESCRIPTION
        })
    });

    return _react2.default.createElement(
        _reactStatic.Head,
        null,
        _react2.default.createElement(
            'title',
            null,
            meta.title
        ),
        _react2.default.createElement('meta', { name: 'description', content: meta.description }),
        _react2.default.createElement('meta', { name: 'author', content: meta.author }),
        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
        _react2.default.createElement('meta', { property: 'og:title', content: meta.og.title }),
        _react2.default.createElement('meta', { property: 'og:site_name', content: meta.og.site_name }),
        _react2.default.createElement('meta', { property: 'og:url', content: meta.og.url }),
        _react2.default.createElement('meta', { property: 'og:description', content: meta.og.description }),
        _react2.default.createElement('meta', { property: 'og:image', content: meta.og.image }),
        _react2.default.createElement('meta', { property: 'og:image:height', content: meta.og.imageHeight }),
        _react2.default.createElement('meta', { property: 'og:image:width', content: meta.og.imageWidth }),
        _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
        _react2.default.createElement('meta', { name: 'twitter:title', content: meta.twitter.title }),
        _react2.default.createElement('meta', {
            name: 'twitter:description',
            content: meta.twitter.description
        }),
        _react2.default.createElement('meta', { name: 'twitter:image', content: meta.twitter.image })
    );
};

exports.default = MetaTags;

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(91);

var _intentoBrain = __webpack_require__(629);

var _intentoBrain2 = _interopRequireDefault(_intentoBrain);

var _HeroBase = __webpack_require__(593);

var _HeroBase2 = _interopRequireDefault(_HeroBase);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroMain = function HeroMain() {
    return _react2.default.createElement(
        _HeroBase2.default,
        { cols: true },
        _react2.default.createElement(
            'div',
            { className: 'hero__col hero__col--image' },
            _react2.default.createElement(
                'div',
                { className: 'hero__image' },
                _react2.default.createElement('img', { src: _intentoBrain2.default, alt: '', className: 'animate-appear' })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'hero__col hero__col--content' },
            _react2.default.createElement(
                'div',
                { className: 'hero__content' },
                _react2.default.createElement(
                    'h1',
                    { className: 'hero__title h1' },
                    'Discover,',
                    _react2.default.createElement('br', null),
                    'evaluate and use',
                    _react2.default.createElement('br', null),
                    'best-of-breed AI'
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'hero__text' },
                    'A\xA0simple and elegant API to\xA0third-party AI\xA0models from many vendors.'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'hero__cta' },
                    _react2.default.createElement(
                        _reactStatic.Link,
                        {
                            tabIndex: '0',
                            onClick: (0, _utils.trackedClick)('Go to catalog clicked', {
                                source: 'Main page',
                                title: 'Next to brain'
                            }),
                            className: 'hero__cta-button button button--lg button--white button--text-blue button--shadow',
                            to: '/api-platform',
                            href: '/api-platform',
                            title: 'Try it'
                        },
                        'Try it'
                    )
                )
            )
        )
    );
};

exports.default = HeroMain;

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logos/intento-brain.9e7a1683.svg";

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/404.3df5fd56.js